import { render } from "./StaffRegisterPage.vue?vue&type=template&id=5d80c8ea&scoped=true"
import script from "./StaffRegisterPage.vue?vue&type=script&lang=js"
export * from "./StaffRegisterPage.vue?vue&type=script&lang=js"

import "./StaffRegisterPage.vue?vue&type=style&index=0&id=5d80c8ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d80c8ea"]])

export default __exports__